module.exports = __webpack_public_path__ + "static/image/history/pc/202010@3x.jpg?471c13b2";